export const PROJECTION_INDEXES = {
  PATIENT_ASSISTANCE_PAID_CLAIM_GENERAL_VIEW: 'patient_assistance_paid_claim_general_view',
  PATIENT_ASSISTANCE_PAID_CLAIM_NEW_INFRASTRUCTURE_TESTING_VIEW:
    'patient_assistance_paid_claim_new_infrastructure_testing_view',
  PATIENT_ASSISTANCE_REQUEST_GENERAL_VIEW: 'patient_assistance_request_general_view',
  PHARMACY_GENERAL_VIEW: 'pharmacy_general_view',
  PHARMACY_PAYMENT_STATEMENT_GENERAL_VIEW: 'pharmacy_payment_statement_general_view',
  BUSINESS_FLOW_CASE_GENERAL_VIEW: 'business_flow_case_general_view',
  OPEN_PHONE_LOG_GENERAL_VIEW: 'open_phone_log_general_view',
  CHANGE_LOG_GENERAL_VIEW: 'change_log_general_view',
  BRIGHTSCORE: 'brightscore',
  BRIGHTSCORE_TEST: 'brightscore_testing',
  USERS_GENERAL_VIEW: 'users_general_view',
  PRESCRIBER_GENERAL_VIEW: 'prescriber_general_view',
} as const;

export type ProjectionIndex = (typeof PROJECTION_INDEXES)[keyof typeof PROJECTION_INDEXES];
